<template>
  <div class="custom-table">
    <table v-if="source === 'IVS Wizard'">
      <thead>
        <tr>
          <th>Id</th>
          <th>Reason</th>
          <th>Source</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ id }}</td>
          <td>{{ location }}</td>
          <td>{{ source }}</td>
        </tr>
      </tbody>
    </table>
    <table v-else>
      <thead>
        <tr>
          <th>Id</th>
          <th v-if="!isFit">System</th>
          <th v-if="!isFit">Location</th>
          <th v-if="!isFit">Calibration</th>
          <th v-if="isFit">Qty Type</th>
          <th>Source</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ id }}</td>
          <td v-if="!isFit">{{ system }}</td>
          <td v-if="!isFit">{{ location }}</td>
          <td v-if="!isFit">{{ calibration }}</td>
          <td v-if="isFit">{{ qtyType }}</td>
          <td>{{ source }}</td>
          <!-- <td>
            <a v-popover tab-index="0" data-bs-toggle="popover" data-bs-trigger="focus hover" data-bs-html="true"
              data-bs-sanitize="false" title="Please Read!" :data-bs-content="prepTrigger(trigger)" class="btn btn-link"
              role="button">
              <i class="fa-solid fa-location-crosshairs"></i>
            </a>
          </td> -->
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'LineDetail',
  props: {
    lineEntry: Object,
    isCopy: { type: Boolean, default: false }
  },
  mounted() {
    console.log('LineDetail mounted', this.lineEntry)
  },
  computed: {
    id() {
      let _data = null
      if (this.lineEntry) {
        _data = this.lineEntry.id
      }
      return _data
    },
    system() {
      let _data = null
      if (this.lineEntry) {
        _data = this.lineEntry.system
      }
      return _data
    },
    location() {
      let _data = null
      if (this.lineEntry) {
        _data = this.lineEntry.location
      }
      return _data
    },
    calibration() {
      let _data = null
      if (this.lineEntry) {
        _data = this.lineEntry.diagnostic
      }
      return _data
    },
    trigger() {
      let _data = null
      if (this.lineEntry) {
        _data = this.lineEntry.triggerNotice
      }
      console.log('trigger', _data)
      return _data
    },
    source() {
      let _data = null
      if (this.lineEntry) {
        _data = this.lineEntry.source
      }
      return _data
    },
    qtyType() {
      let _data = null
      if (this.lineEntry) {
        _data = this.lineEntry.item
      }
      return _data
    },
    isFit() {
      let _is = false
      if (this.lineEntry) {
        if (this.lineEntry.source === 'FIT REV') {
          _is = true
        }
      }
      return _is
    }
  },
  methods: {
    prepTrigger(content) {
      let _data = null
      // console.log('Content', content)
      if (content) {
        let trigger = null
        if (content.toUpperCase().indexOf('<TRIGGER') >= 0) {
          trigger = content.slice(15, -16)
        } else {
          trigger = content
        }
        trigger = trigger.replace(/&comma;/g, ',')
        // console.log('Trigger', trigger)
        _data = `<div class='popover' role='tooltip' style='overflow-x: hidden !important;  overflow-y: auto !important;  max-height: 200px !important;'><div class='popover-body' >${trigger}</div></div>`
      }
      return _data
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-table {
  width: 80%;
  margin: 10px;

  table {
    width: 100%;
    border-collapse: collapse;

    th,
    td {
      padding: 8px;
      text-align: left;
      border-bottom: 1px solid #ddd;
    }

    th {
      font-weight: 500;
    }

    td a {
      color: red;
      text-decoration: none;
    }
  }
}
</style>